module.exports = __webpack_public_path__ + "img/rule2.eae09eb1.png";